module.exports = __webpack_public_path__ + "dashboard/img/filter.d18a3ba7c1fab4b298fd9a5c4f46d648.svg";